// The product's name, set once for a build and used everywhere it is shown (01-design.md).
export const PRODUCT = 'desyr';
export const VERSION = __APP_VERSION__;
